import { useQuery } from 'react-query';

import { handleRefreshToken } from 'utils/refreshToken';
import { API_URL, HEADER_ACCEPT_HR } from 'utils/apiConstants';
import { FetchError } from 'utils/FetchError';
import { GetUsersRolesParams, GetUsersRolesData } from 'interfaces/hooks/permissionsHooksInterfaces';

export const useGetUsersRoles = ({ companyUuid, onError }: GetUsersRolesParams): GetUsersRolesData => {
  const { data: usersRolesData } = useQuery(
    ['users_roles', companyUuid],
    async () => {
      await handleRefreshToken();

      const token = localStorage.getItem('token');

      const res = await fetch(`${API_URL}/company_roles/${companyUuid}/?role=hr_user`, {
        method: 'GET',
        headers: {
          Accept: `${HEADER_ACCEPT_HR}`,
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.ok) {
        return res.json();
      }
      throw new FetchError(res);
    },
    {
      refetchOnWindowFocus: false,
      refetchOnmount: false,
      onError,
      refetchOnReconnect: false,
      enabled: !!companyUuid,
      select: (res) => res.data,
    }
  );

  return {
    usersRolesData,
  };
};
